import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcFinanceBreakdownSectionClasses,
} from '@dxp-module/themes'

const financeBreakdownSectionStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcFinanceBreakdownSectionClasses
>(
  ({ palette }) => ({
    breakdownSectionContainer: {
      paddingTop: 14,
      paddingBottom: 14,
      borderTop: `1px solid ${palette.common.black}`,
    },
    divider: {
      marginRight: 25,
      marginBottom: 20,
    },
  }),
  { name: 'FC_FinanceBreakdownSection' }
)

export default financeBreakdownSectionStyles
